import { Route } from "react-router-dom";

// since that we're not using the Content component for nothing, it was removed
// and to keep the less amount of changes it was redefined for the following
export const ContentRoute = Route;

export default ContentRoute;
